var contentListAjax = false;

var initializeContentListBlock = function(block){
	
	var slideColumns = parseInt(jQuery(".posts[data-columns]", block).attr("data-columns"));
	
	jQuery('.slick:not(.slick-initialized)', block).slick({
		slidesToShow: slideColumns,
		slidesToScroll: slideColumns,
		rows: 1,
		slidesPerRow: slideColumns,
		dots: false,
		arrows: true,
		autoplay: false,
		autoplaySpeed: 3000,
		fade: false,
		easing: "linear",
		pauseOnHover: false,
		infinite: true,
		draggable: false,
		swipe: true,
		adaptiveHeight: false,
		responsive: [
		{
		  breakpoint: 900,
		  settings: {
		  	  slidesToShow: 2,
			  slidesToScroll: 2,
			  slidesPerRow: 2,
		  }
		},
		{
		  breakpoint: 500,
		  settings: {
			  slidesToShow: 1,
			  slidesToScroll: 1,
			  slidesPerRow: 1,
		  }
		}
	  ]
	});
	
	jQuery("a.show-field-trip-dates", block).on("click", function(){
		
		var parent = jQuery(this).parents(".card");
		
		parent.addClass("show-field-trip-dates");
		
	});
	
	jQuery("a.close-field-trip-dates", block).on("click", function(){
		
		var parent = jQuery(this).parents(".card");
		
		parent.removeClass("show-field-trip-dates");
		
	});
	
	jQuery("a.show-modal").on("click", function(){
		
		var current = jQuery(this);
		var showID = current.attr("data-show-id");
		var modalContent = jQuery("div.show-modal .content");
		
		modalContent.hide();
		
		jQuery.ajax({
			url:"/wp-admin/admin-ajax.php",
			type:'POST',
			data:'action=get_show_modal_content&show_id='+ showID,
			success:function(results){
				
				jQuery("div.show-modal .content").html(results);
				
				modalContent.show();
				
			}
		});
		
	});
	
}

//initialize each block on front end
jQuery(document).ready(function(){
	jQuery('.wp-block-content-list').each(function(){
		initializeContentListBlock(jQuery(this));
	});
});

//initialize dynamic block preview in the editor
if(window.acf)
	window.acf.addAction('render_block_preview/type=content-list', initializeContentListBlock);
